var MasonryBlocks = function () {

  var $masonryContainer, mason;
  var debouncedAdjustMason = $.debounce(50, adjustMason);

  function init() {
    $masonryContainer = $('.masonry-block');
    if (!$masonryContainer.length) return;

    registerMediaQueries();
  }

  function layout() {
    if (typeof Masonry === 'undefined') {
      let err = 'Missing Masonry. Aborting layout';
      console.error(err);
      return new Error(err);
    }
    var options = {
      transitionDuration: 0,
      columnWidth: $masonryContainer.hasClass('third') ? '.third-width' : '.half-width',
      percentPosition: true
    };
    mason = new Masonry($masonryContainer[0], options);
    adjustMason();
  }

  function adjustMason() {
    setTimeout(function () {
      mason.layout();
      if ($masonryContainer[0].offsetHeight === 0) {
        $masonryContainer[0].style.position = 'relative';
        $masonryContainer[0].style.height = 'auto';

        for (var a = 0; a < $masonryContainer[0].children.length; a++) {
          const child = $masonryContainer[0].children[a];

          if (child.classList.contains('three-columns-text-block') > -1) {
            child.style.position = 'relative';
          }
        }
      }
      $masonryContainer.removeClass('content-hidden');
    }, 0);
  }

  function registerMediaQueries() {
    enquire.register('screen and (min-width: 768px)', {
      match: function () {
        layout();
        $(window).on('resize', debouncedAdjustMason);

      },
      unmatch: function () {
        if (typeof mason !== 'undefined') mason.destroy();
        $('section.body').attr('style', '');
        $(window).off('resize', debouncedAdjustMason);
      }
    });
  }

  return {
    init: init
  }

}();
